import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import HeroPage from "./pages/HeroPage";
import WorkPage from "./pages/WorkPage";
import SpeakingPage from "./pages/SpeakingPage";
import WritingPage from "./pages/WritingPage";
import AboutPage from "./pages/AboutPage";
import ProjectDetail from "./components/ProjectDetail";
import styles from "./styles/Header.module.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <span className={styles.footerSig}>With ♥ from Mercy</span>
        <span>© Mercy Mofoluwawo {new Date().getFullYear()} — Today. All rights reserved</span>
      </div>
    </footer>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HeroPage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/speaking" element={<SpeakingPage />} />
        <Route path="/writing" element={<WritingPage />} />
        <Route path="/about" element={<AboutPage />} />
<Route path="/project/:projectId" element={<ProjectDetail />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
